import Vue from 'vue';
import VueRouter, { NavigationGuardNext, Route, RouteConfig } from 'vue-router';

Vue.use(VueRouter);

// Store and store types
import Store from '@/store';
import { StepsMutation } from '@/store/store.types';

// Step routes
import IntroRoutes from '../steps/Intro/routes';
import SpacesRoutes from '../steps/Spaces/routes';
import SystemsRoutes from '../steps/Systems/routes';
import ProductsRoutes from '../steps/Products/routes';
import OverviewRoutes from '../steps/Overview/routes';
import PersonalDetailsRoutes from '../steps/PersonalDetails/routes';

/**
 *  Construct the routes based on every step's routes.
 */
const routes: RouteConfig[] = [
    ...IntroRoutes,
    ...SpacesRoutes,
    ...SystemsRoutes,
    ...ProductsRoutes,
    ...OverviewRoutes,
    ...PersonalDetailsRoutes,
];

/**
 *  Create and export the router.
 */
const router: VueRouter = new VueRouter({
    mode: 'history',
    routes,
});

/**
 *  Used to check if the forwarded route has query params.
 */
function hasQueryParams(route: Route) {

    return !!Object.keys(route.query).length;

}

/**
 *
 *  Keep storing the step to which is being navigated on navigation.
 *
 *  (i) Which on his turn updates some layout stuff for the step
 *
 */
router.beforeEach((to: Route, from: Route, next: NavigationGuardNext<Vue>) => {

    /**
     *  Store the step data of the step to which is navigated.
     */
    Store.commit(StepsMutation.CURRENT, to.meta ?? null);

    /**
     *  Preserve the query params.
     */
    if (!hasQueryParams(to) && hasQueryParams(from)) {

        router.push({ path: to.path, query: from.query });

        return;

    }

    next();

});

export default router;
